
import { Box, Button, Card, CardContent, Grid, InputLabel, TextField, Typography } from '@mui/material';
import AdminWrapper from 'csam/admin/components/AdminWrapper';
import { getGraphClient } from 'csam/admin/pages/phishing-emails/getGraphClient';
import React, { useContext, useState, useRef } from 'react';
import 'react-quill/dist/quill.snow.css';
import { fixed,getImage } from 'csam/utils/Constants';
import { useMsal } from '@azure/msal-react';
import EmailInputWithTags from './EmailInputWithTags';
import { useAuthenticatedQuery,useAuthenticatedMutation } from 'csam/api/api';
// import { fixed} from 'csam/utils/Constants';
import LocaleContext from 'csam/components/LocaleContext';
import AdminPageLoader from 'csam/admin/components/AdminPageLoader';
import AdminInternalError from '../AdminInternalError';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import ReactQuill, { Quill } from 'react-quill';
import QuillResizeImage from 'quill-resize-image';

Quill.register('modules/resize', QuillResizeImage);
interface EmailState {
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  body: string;
  additionalData: Object | { [key: string]: string }[];
  excelFile: File | null; 
}

interface EmailTemplateData {
  id: number;
  template_title: string;
  email_subject: string;
  email_body: string;
  created_at: string;
  status: number;
}

interface TemplateResponse {
  success: boolean;
  data: EmailTemplateData;
}

const ComposeEmail = () => {
  const { instance, accounts } = useMsal();
  const [open, setOpen] = useState(false);
  const [emailContent, setEmailContent] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState<string | null>(null);
  const { locale } = useContext(LocaleContext);
 const [selectedImage, setSelectedImage] = useState<File | null>(null);
const [uploadedImageUrl, setUploadedImageUrl] = useState<string | null>(null);


const modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['bold', 'italic', 'underline'],
    [{ align: [] }],
    ['link', 'image'],
  ],
  resize: {},
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  }, // leave empty
};
const quillRef = useRef(null);
const handlePhishingImageSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (file) setSelectedImage(file);
};
  const primaryEmail = 'Security_Compliance_Awareness@ab-inbev.com';
  const secondaryEmail = 'GISP_Support@ab-inbev.com';

const uploadImageMutation = useAuthenticatedMutation(
  ['upload-phishing-image', 'POST'],
  (formData: FormData) => ({
    url: `https://react-cybersecurityandcompliance-awareness.ab-inbev.com/api/pemail/upload-image`,
    method: 'POST',
    data: formData,
  })
);
  const localeFromStorage = localStorage.getItem('locale') || 'en';
  const { isPending, error, data } = useAuthenticatedQuery<TemplateResponse[]>([locale], {
    url: `${fixed}admin/${locale || localeFromStorage}/email_templates`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  const styles = {
    quillContainer: {
    minHeight: '300px',  // or height: '300px'
    backgroundColor: 'white',
    color: 'black',
    border: '1px solid #ccc',
  },
    toolbar: {
      backgroundColor: '#f5f5f5', // Light background for toolbar
      border: '1px solid #ddd',    // Light border for toolbar
    },
    editor: {
      backgroundColor: 'white',    // Light background for the editor area
      color: 'black',              // Text color for editor content
    }
  };

  const handleTemplateSelect = (templateId: string) => {
    setSelectedTemplate(templateId);
  };
const handleUploadPhishingImage = async () => {
  if (!selectedImage) return;

  const formData = new FormData();
  formData.append('image', selectedImage);
  formData.append('locale', locale || 'en');

  try {
    const res = await uploadImageMutation.mutateAsync(formData);
    if (res.success) {
      setUploadedImageUrl(res.data.image_url);
      toast.success('Image uploaded successfully!');
      setSelectedImage(null);
    } else {
      toast.error('Upload failed');
    }
  } catch (err) {
    console.error(err);
    toast.error('Error uploading image');
  }
};
  const [fromEmails, setFromEmails] = useState<string[]>([primaryEmail]);
  const [email, setEmail] = useState<EmailState>({
    to: [],
    cc: [],
    bcc: [],
    subject: '',
    body: '',
    additionalData: [],
    excelFile: null
  });

  const [_emailInput, setEmailInput] = useState('');

  const encodeHTML = (str: string) => {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };




const sendEmailMutation = useAuthenticatedMutation(
  ['send-email-excel', 'POST'],
  (formData: FormData) => ({
    url: `https://react-cybersecurityandcompliance-awareness.ab-inbev.com/api/email/send-email-excel`,
    method: 'POST',
    data: formData, // same as your uploadImageMutation
  })
);

const handleSendEmailToBackend = async () => {
  if (!email.to.length) {
    toast.error('No recipients found. Upload an Excel file first.');
    return;
  }

  // Create a new FormData object
  const formData = new FormData();

  // Append additional fields to the formData
  formData.append('subject', email.subject);
  formData.append('body', emailContent);

  // Handle Excel data - this is where we make sure the file is attached
  const excelFile = email.excelFile;  // This assumes you've set email.excelFile after file upload
  if (excelFile) {
    formData.append('file', excelFile);
  } else {
    toast.error('Please upload an Excel file first!');
    return;
  }

  // If you want to send additional data (like to, cc, bcc etc.)
  const excelData = email.to.map((to, i) => ({
    to,
    cc: email.cc.filter((_, idx) => idx === i),
    bcc: email.bcc.filter((_, idx) => idx === i),
    additionalData: email.additionalData[i],
  }));

  // Append the JSON stringified excel data (the actual content)
  formData.append('emails', JSON.stringify(excelData));

  // Now send the request
   try {
  const res = await sendEmailMutation.mutateAsync(formData);

  if (res.success) {
    setOpen(false); // ✅ closes modal

    alert("Emails sent successfully!"); // ✅ popup message
  } else {
    toast.error(res.message || 'Failed to send emails.');
  }
} catch (err) {
  console.error(err);
  toast.error('Error sending emails.');
}
};


//   const handleUploadExcel = (e: React.ChangeEvent<HTMLInputElement>) => {
//   const file = e.target.files?.[0];
//   if (!file) return;

//   const reader = new FileReader();
//   reader.onload = (event) => {
//     const data = event.target?.result;
//     if (!data) return;

//     const workbook = XLSX.read(data, { type: 'binary' });
//     const firstSheetName = workbook.SheetNames[0];
//     const worksheet = workbook.Sheets[firstSheetName];
//     const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

//     // Map Excel rows to emails
//     const emails = jsonData.map((row) => ({
//       to: row.Email || '', // ensure your column name is Email
//       cc: row.CC ? row.CC.split(/[ ,;]/).map((x) => x.trim()) : [],
//       bcc: row.BCC ? row.BCC.split(/[ ,;]/).map((x) => x.trim()) : [],
//       additionalData: row,
//     }));

//     setEmail((prev) => ({
//       ...prev,
      
      
//       to: emails.map((e) => e.to),
//       cc: emails.flatMap((e) => e.cc),
//       bcc: emails.flatMap((e) => e.bcc),
//       additionalData: emails.map((e) => e.additionalData),
//       excelFile: file,
//     }));
//   };

//   reader.readAsBinaryString(file); // important for XLSX
// };

const handleUploadExcel = (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (event) => {
    const data = event.target?.result;
    if (!data) return;

    const workbook = XLSX.read(data, { type: 'binary' });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

    // 👇 this is the new version that matches your Excel: to, cc, bcc
    setEmail((prev) => ({
      ...prev,
      to: jsonData.map((row) => row.to || ''),
      cc: jsonData
        .map((row) =>
          row.cc
            ? row.cc
                .split(/[ ,;]/)
                .map((x: string) => x.trim())
                .filter(Boolean)
            : []
        )
        .flat(),
      bcc: jsonData
        .map((row) =>
          row.bcc
            ? row.bcc
                .split(/[ ,;]/)
                .map((x: string) => x.trim())
                .filter(Boolean)
            : []
        )
        .flat(),
      additionalData: jsonData,
      excelFile: file,
    }));
  };

  reader.readAsBinaryString(file);
};





  if (isPending) return <AdminPageLoader />;
  if (error) return <div>Error: {error.message}</div>;
  if (data && !data.success) return <AdminInternalError />;
  const templates = data.data || [];

  const handleOpen = () => {
    const selectedTemplateDetails = templates.find((template) => template.id === selectedTemplate);
    if (selectedTemplateDetails) {
      const imageUrl = selectedTemplateDetails.image
        ? `${getImage}email_templates/${selectedTemplateDetails.image}`
        : '';

      const formattedBody = selectedTemplateDetails.email_body
        .replace(/\n/g, '<br/>')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

      const emailBodyWithImage = imageUrl
        ? `<img src="${imageUrl}" alt="Email Template Image" style="max-width: 100%"/><br/>${formattedBody}`
        : formattedBody;

      setEmail((prevState) => ({
        ...prevState,
        subject: selectedTemplateDetails.email_subject,
        body: emailBodyWithImage,
      }));
      setEmailContent(emailBodyWithImage);
    }
    setOpen(true);
  };

  const handleClose = () => setOpen(false);





  return (
    <AdminWrapper>
      <Box className="pageHeader">
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Typography variant="h6"> Send Email </Typography>
        </Box>
      </Box>

      <Box>
        <Box className="form-group" mb={4}>
          <InputLabel>Upload Excel file</InputLabel>
          <TextField type="file" name="file" onChange={handleUploadExcel} fullWidth inputProps={{ accept: '.xlsx,.csv' }}/>
        </Box>


        <Grid container spacing={3} className="preDefineTemplates">
          {templates.map((template) => (
            <Grid item md={4} mb={3} key={template.id}>
              <Card
                onClick={() => handleTemplateSelect(template.id)}
                sx={{
                  backgroundColor: selectedTemplate === template.id ? '#292929 !important' : '#2d2d29',
                  cursor: 'pointer',
                  boxShadow: '0px 3px 8px #5c5c5c',
                }}
                className="templateCard"
              >
                <CardContent>
                  <Typography variant="h6">{template.template_title}</Typography>
                  <Typography variant="body1">{template.email_body}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Button variant="contained" color="primary" onClick={handleOpen}>
          Send Email
        </Button>
      </Box>

      {open && (
        <div className="modal">
          <div className="modal-content">
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" component="h2">
                Compose Email
              </Typography>
              <span className="close" onClick={handleClose}>
                &times;
              </span>
            </Box>

            <EmailInputWithTags label="From" emails={fromEmails} onEmailsChange={setFromEmails} readOnly={true} />

            <EmailInputWithTags
              label="To"
              emails={email.to}
              readOnly={true}
              onEmailsChange={(emails) => setEmail((prevState) => ({ ...prevState, to: emails }))}
            />

            <EmailInputWithTags
              label="CC"
              emails={email.cc}
              readOnly={true}
              onEmailsChange={(emails) => setEmail((prevState) => ({ ...prevState, cc: emails }))}
            />

            <EmailInputWithTags
              label="BCC"
              emails={email.bcc}
              readOnly={true}
              onEmailsChange={(emails) => setEmail((prevState) => ({ ...prevState, bcc: emails }))}
            />

            <Box className="form-group">
              <InputLabel>Email Subject</InputLabel>
              <TextField
                placeholder="Enter email subject"
                size="small"
                name="email_subject"
                value={email.subject}
                onChange={(e) => setEmail((prevState) => ({ ...prevState, subject: e.target.value }))}
                fullWidth
              />
            </Box>

            <Box className="form-group">
              <InputLabel>Body</InputLabel>
              <input
  type="file"
  id="customImageInput"
  style={{ display: 'none' }}
  accept="image/*"
  onChange={handlePhishingImageSelect}
/>

        <ReactQuill
          value={emailContent}
          onChange={setEmailContent}
          modules={modules}
          theme="snow"
          style={styles.quillContainer}

          // style={{ minHeight: 300, backgroundColor: 'white', color: 'black' }}
        />
            </Box>
            <Box className="fixed-bar">
              <Button variant="contained" color="primary" onClick={handleSendEmailToBackend}>
                Send Email
              </Button>
            </Box>
          </div>
        </div>
      )}
    </AdminWrapper>
  );
};

export default ComposeEmail;
